<template>
  <div class="homepage company-landing">
    <div class="loading-data-wrapper" v-if="disableAPI">
      <div class="loading-data">
        <div></div><div></div><div></div>
      </div>
    </div>
    <div class="landing-page-edit-panel"
         v-if="isGM()">
      <div class="wrapper" :class="[{ 'active': landingPanel }]">
        <div class="landing-page-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
        <div v-if="editHistory === false">
          <div class="action-btn"
               @click.prevent="pageMetaEdit = true">Edit page meta</div>
          <div class="action-btn"
               v-if="pageEditMode === false"
               @click.prevent="pageEditSwitch()">Edit page content</div>
          <div class="action-btn"
               @click.prevent="activateEditHistory()">Page edit history</div>
        </div>
        <div v-if="editHistory === true">
          <div class="form-group">
            <div class="form-element">
              <label for="page-versions" class="form-label color-2-63">Page save history</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable = false
                        @input="changeLandingPage($event)"
                        :options="getPageVersionsForSelect()"
                        data-lpignore="true"
                        id="page-versions" />
            </div>
          </div>
        </div>
        <div class="action-btn-bottom">
          <div class="action-btn action-btn-save"
               v-if="pageEditMode === true"
               @click.prevent="updateLandingPage()">Save</div>
          <div class="action-btn action-btn-discard"
               @click.prevent="discardPageEdit()">Discard</div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper hero-section"
         v-show="!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showHero"
                 v-model="content.heroSection.hideSection" />
          <label :for="'showHero'">Hide this section</label>
        </div>
        <div class="flex-section">
          <div class="left-content">
            <div class="hero-title">
              <h1 class="content color-2-100"
                  v-html="content.heroSection.title"
                  v-if="!pageEditMode">
              </h1>
              <textarea class="content color-2-100"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.title"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.title }}</textarea>
            </div>
            <div class="hero-description">
              <p class="content"
                 v-html="content.heroSection.description"
                 v-if="!pageEditMode">
              </p>
              <textarea class="content"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.description"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.description }}</textarea>
            </div>
            <div class="hero-register">
              <div class="hero-separator"></div>
              <div class="landing-page-login-wrapper">
                <div class="tcc-form">

                </div>
                <form class="tcc-form" v-on:submit="submitCallbackRequest()">
                  <div class="tcc-form-group">
                    <label for="register-name">First name*</label>
                    <input id="register-name"
                           class="tcc-form-element tcc-form-element__input"
                           :class="[{ 'border-1-20': registerForm.name !== '' || registerForm.nameFocus, 'not-empty': registerForm.name !== '' || registerForm.nameFocus, 'has-error': errors.has('First name') }]"
                           data-lpignore="true"
                           type="text"
                           name="First name"
                           v-validate="'required'"
                           placeholder="Type in here..."
                           @focus="registerForm.nameFocus = true"
                           @blur="registerForm.nameFocus = false"
                           v-model="registerForm.name" />
                    <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
                  </div>
                  <div class="tcc-form-group">
                    <label for="register-surname">Last name*</label>
                    <input id="register-surname"
                           class="tcc-form-element tcc-form-element__input"
                           :class="[{ 'border-1-20': registerForm.surname !== '' || registerForm.surnameFocus, 'not-empty': registerForm.surname !== '' || registerForm.surnameFocus, 'has-error': errors.has('Last name') }]"
                           data-lpignore="true"
                           type="text"
                           name="Last name"
                           v-validate="'required'"
                           placeholder="Type in here..."
                           @focus="registerForm.surnameFocus = true"
                           @blur="registerForm.surnameFocus = false"
                           v-model="registerForm.surname" />
                    <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
                  </div>
                  <div class="tcc-form-group">
                    <label for="register-phone">Contact number*</label>
                    <input id="register-phone"
                           class="tcc-form-element tcc-form-element__input"
                           :class="[{ 'border-1-20': registerForm.phone !== '' || registerForm.phoneFocus, 'not-empty': registerForm.phone !== '' || registerForm.phoneFocus, 'has-error': errors.has('Contact number') }]"
                           data-lpignore="true"
                           type="text"
                           name="Contact number"
                           v-validate="'required'"
                           placeholder="Type in here..."
                           @focus="registerForm.phoneFocus = true"
                           @blur="registerForm.phoneFocus = false"
                           v-model="registerForm.phone" />
                    <span class="form-field-error" v-if="this.errors.has('Contact number')">{{ this.errors.first('Contact number') }}</span>
                  </div>
                  <div class="tcc-form-group">
                    <label for="register-email">Email address*</label>
                    <input id="register-email"
                           class="tcc-form-element tcc-form-element__input"
                           :class="[{ 'border-1-20': registerForm.email !== '' || registerForm.emailFocus, 'not-empty': registerForm.email !== '' || registerForm.emailFocus, 'has-error': errors.has('Email address') }]"
                           data-lpignore="true"
                           type="email"
                           name="Email address"
                           v-validate="'required|email'"
                           placeholder="Type in here..."
                           @focus="registerForm.emailFocus = true"
                           @blur="registerForm.emailFocus = false"
                           v-model="registerForm.email" />
                    <span class="form-field-error" v-if="this.errors.has('Email address')">{{ this.errors.first('Email address') }}</span>
                  </div>
                  <div class="tcc-form-group">
                    <label for="register-subject">Subject (Short but descriptive)*</label>
                    <input id="register-subject"
                           class="tcc-form-element tcc-form-element__input"
                           :class="[{ 'border-1-20': registerForm.subject !== '' || registerForm.subjectFocus, 'not-empty': registerForm.subject !== '' || registerForm.subjectFocus, 'has-error': errors.has('Subject') }]"
                           data-lpignore="true"
                           type="text"
                           name="Subject"
                           v-validate="'required'"
                           placeholder="Type in here..."
                           @focus="registerForm.subjectFocus = true"
                           @blur="registerForm.subjectFocus = false"
                           v-model="registerForm.subject" />
                    <span class="form-field-error" v-if="this.errors.has('Subject')">{{ this.errors.first('Subject') }}</span>
                  </div>
                  <p id="messageDescription" class="callback-request-message-info">
                    Tell us about the difficulties that you encountered with Clear Assured and we’ll contact you with a solution shortly.
                  </p>
                  <div class="tcc-form-group">
                    <label for="register-message">Description (Please be as descriptive as possible)*</label>
                    <textarea id="register-message"
                              class="tcc-form-element tcc-form-element__textarea"
                              :class="[{ 'border-1-20': registerForm.message !== '' || registerForm.messageFocus, 'not-empty': registerForm.message !== '' || registerForm.messageFocus, 'has-error': errors.has('Your message') }]"
                              data-lpignore="true"
                              type="text"
                              name="Your message"
                              aria-describedby="messageDescription"
                              v-validate="'required'"
                              placeholder="Type in here..."
                              @focus="registerForm.messageFocus = true"
                              @blur="registerForm.messageFocus = false"
                              v-model="registerForm.message"></textarea>
                    <span class="form-field-error" v-if="this.errors.has('Your message')">{{ this.errors.first('Your message') }}</span>
                  </div>
                  <div class="hero-register-terms">
                    <p>Fields marked with an asterisk (<span>*</span>) are mandatory.</p>
                    <div class="tcc-form-group">
                      <input type="checkbox"
                             class="tcc-form-element tcc-form-element__checkbox"
                             :class="[{ 'has-error': errors.has('Privacy policy') }]"
                             data-lpignore="true"
                             id="register-privacy"
                             name="Privacy policy"
                             v-validate="'required'"
                             v-model="registerForm.privacy" />
                      <label for="register-privacy">Agree to the Clear Assured <router-link to="/privacy-policy">Privacy Policy</router-link>*.</label>
                      <span class="form-field-error" v-if="this.errors.has('Privacy policy')">{{ this.errors.first('Privacy policy') }}</span>
                    </div>
                  </div>
                  <div class="tcc-form-actions">
                    <button type="submit" class="tcc-form-action"
                            :class="[{ 'submitting': registerForm.requestInProgress }]"
                            @click.prevent="submitCallbackRequest()">
                      Submit help request
                    </button>
                  </div>
                  <div class="tcc-form-message"
                       aria-live="assertive">
                    <div v-if="this.formStatus.submitting" class="visually-hidden">
                      Submitting
                    </div>
                    <template v-else>
                      <template v-if="formStatus.shown">
                        <h2 v-if="formStatus.title !== ''">
                          <template v-if="formStatus.success">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" class="svg-inline--fa fa-circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"></path>
                            </svg>
                          </template>
                          <template v-else>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-xmark" class="svg-inline--fa fa-circle-xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"></path>
                            </svg>
                          </template>
                          {{ formStatus.title }}
                        </h2>
                        <p v-if="formStatus.body !== ''">
                          {{ formStatus.body }}
                        </p>
                      </template>
                      <template v-else-if="this.errors.items && this.errors.items.length">
                        <h2>
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-exclamation" class="svg-inline--fa fa-circle-exclamation" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"></path>
                          </svg>
                          Some fields are missing.
                        </h2>
                        <p>Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.</p>
                      </template>
                    </template>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="right-content">
            <div class="hero-image">
              <div class="content"
                   :title="content.heroSection.altImage"
                   v-bind:style="{ backgroundImage: getImage(content.heroSection.image) }">
                <input type="text"
                       placeholder="Alt image"
                       v-if="pageEditMode && isGM()"
                       class="landing-page-image-alt"
                       v-model="content.heroSection.altImage" />
                <label :for="'hero-image-upload'"
                       v-if="pageEditMode && isGM()"
                       class="hero-upload"></label>
                <input type="file"
                       v-if="pageEditMode && isGM()"
                       @change="onFileChange($event, content.heroSection, 'image')"
                       :id="'hero-image-upload'" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="pageMetaEdit && isGM()">
      <div class="modal-inner" ref="metaEditPopup">
        <h1>Change page meta</h1>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="popup-footer-edit">
          <div>
            <div class="meta-description">
              <label for="meta-title">Title</label>
              <input id="meta-title"
                     placeholder="Page meta title"
                     v-model="metaData.title" />
            </div>
            <div class="meta-description">
              <label for="meta-description">Description</label>
              <textarea id="meta-description"
                        placeholder="Page meta description"
                        v-model="metaData.description">{{ metaData.description }}</textarea>
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
          <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'

export default {
  name: 'need-help-request',
  data () {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        }
      },
      windowWidth: window.innerWidth,
      serverValidation: {
        errors: []
      },
      disableAPI: false,
      activePopup: null,
      registerForm: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        privacy: false,
        nameFocus: false,
        surnameFocus: false,
        emailFocus: false,
        phoneFocus: false,
        subjectFocus: false,
        messageFocus: false
      },
      confOpened: null,
      formStatus: {
        shown: false,
        success: false,
        title: '',
        body: '',
        submitting: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'getIsLoggedIn',
      'getUserRole',
      'selectedHightCont',
      'getSelectedFontSize',
      'getConfData'
    ])
  },
  methods: {
    ...mapActions([
      'clearConfAction',
      'initConfAction',
      'redirect',
      'getRoles',
      'setFontSizeActive',
      'setColorPaletteActive'
    ]),
    updateLandingPage () {
      if (this.disableAPI) return
      let pageData = {
        slug: 'need-help',
        body: JSON.stringify(this.content)
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then(() => {
        this.disableAPI = false
        this.getLandingPage(null, true)
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    updateMeta () {
      if (this.disableAPI) return
      let pageData = {
        title: this.metaData.title,
        slug: 'need-help',
        description: this.metaData.description
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then(() => {
        this.disableAPI = false
        document.location.reload()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getPageVersions () {
      let self = this
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.staticpagechanges + '/need-help', api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.pageVersions = []
        for (let index in res.body) {
          if (!res.body.hasOwnProperty(index)) {
            return
          }
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          })
        }
        this.editHistory = true
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getPageVersionsForSelect () {
      return this.pageVersions
    },
    changeLandingPage (el) {
      this.getLandingPage(el.id)
    },
    convertDateTime (payload) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      let newHours = hours % 12 ? hours % 12 : 12
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
      let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
      return dateString + ' ' + timeString
    },
    getLandingPage (id, refresh) {
      if (this.disableAPI) return
      this.disableAPI = true
      let body = {
        slug: 'need-help'
      }
      if (id) {
        body.id = id
      }
      this.$http.post(api.URLS.staticpage + '/need-help', body, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        let pageData = JSON.parse(res.data.body)
        if (pageData.footerData) {
          this.content.footerData = pageData.footerData
        }
        if (pageData.heroSection) {
          this.content.heroSection = pageData.heroSection
        }
        if (res.data.logo) {
          this.landing.logo = res.data.logo
        }
        this.metaData.title = res.data.title
        this.metaData.description = res.data.description
        if (this.metaData.title && this.metaData.title !== '') {
          document.title = this.metaData.title
        }
        this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
        this.content.title = this.metaData.title
        this.content.description = this.metaData.description
        this.content = {...this.content, ...pageData}
        if (id) {
          this.pageEditSwitch()
        } else {
          if (refresh) {
            this.pageEditMode = false
          }
        }
        if (this.$route.name === 'edit-need-help') {
          this.$nextTick(() => {
            this.autoSizeOnInit()
          })
        }
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    activateEditHistory () {
      this.getPageVersions()
    },
    addPageMeta (name, data) {
      let meta = document.createElement('meta')
      meta.name = name
      for (let index in data) {
        if (!data.hasOwnProperty(index)) {
          return
        }
        meta.setAttribute(data[index].name, data[index].value)
      }
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    discardChanges () {
      this.getLandingPage(null, true)
    },
    pageEditSwitch () {
      this.confOpened = 'edit'
      this.initConfAction({
        actionName: 'editLanding'
      })
    },
    pageEditSwitchConfirmed () {
      this.pageEditMode = true
      this.$nextTick(() => {
        this.autoSizeOnInit()
      })
      this.getConfData.actionConfirmed = false
    },
    discardPageEdit () {
      this.discardChanges()
      if (this.editHistory) {
        this.editHistory = false
      } else {
        this.landingPanel = false
      }
    },
    onFileChange (e, target, item) {
      let input = e.target
      let self = this
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        let reader = new FileReader()
        reader.onload = function (e) {
          let fileName = input.files[0].name
          let extension = fileName.split('.').pop().toLowerCase()
          if (self.disableAPI) return
          let pageData = {
            file: e.target.result,
            extension: extension
          }
          self.disableAPI = true
          self.$http.post(api.URLS.uploadFile, pageData, api.headersAuthSettings).then((res) => {
            self.disableAPI = false
            target[item] = res.body
          }).catch((err) => {
            self.disableAPI = false
            console.log('err', err)
          })
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    getImagePath () {
      return api.serverURL + '/uploads/images/content/'
    },
    isBase64 (payload) {
      if (!payload && payload !== '') {
        return true
      }
      return payload.indexOf('data:') !== -1
    },
    getImage (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
    },
    closePopup () {
      this.activePopup = null
      this.pageMetaEdit = false
      this.$nextTick(() => {
        if (this.$refs.slick) {
          this.$refs.slick.reSlick()
        }
      })
    },
    autoSize (el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0'
        el.target.style = 'height:' + el.target.scrollHeight + 'px'
      }, 0)
    },
    autoSizeOnInit () {
      let textAreas = document.getElementsByTagName('textarea')
      for (let i = 0; i < textAreas.length; i++) {
        let item = textAreas[i]
        setTimeout(function () {
          item.style = 'height:auto; padding:0'
          item.style = 'height:' + item.scrollHeight + 'px'
        }, 0)
      }
    },
    isGM () {
      let isLogged = this.getIsLoggedIn
      if (!isLogged) {
        return false
      }
      let userRole = this.getUserRole
      return userRole === 'gm'
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    submitCallbackRequest () {
      this.formStatus.submitting = true
      this.$validator.validateAll().then((result) => {
        if (!result) {
          setTimeout(() => {
            this.scrollToTheMessage()
          }, 100)
          this.formStatus.submitting = false
          return
        }
        let data = {
          name: this.registerForm.name,
          surname: this.registerForm.surname,
          email: this.registerForm.email,
          phone: this.registerForm.phone,
          subject: this.registerForm.subject,
          message: this.registerForm.message,
          terms: true,
          privacy: this.registerForm.privacy,
          type: 2
        }
        this.$http.post(api.URLS.callbackRequest, data).then(() => {
          this.formStatus.submitting = false
          this.formStatus.shown = true
          this.formStatus.success = true
          this.formStatus.title = 'You have successfully submitted your need help request.'
          this.formStatus.body = 'Thank you for getting in touch. We usually reply to the need help request in maximum 24 hours from when it was submitted to us. If your inquiry is urgent, please give us a call.'
          this.registerForm.name = ''
          this.registerForm.surname = ''
          this.registerForm.email = ''
          this.registerForm.phone = ''
          this.registerForm.subject = ''
          this.registerForm.message = ''
          this.registerForm.privacy = false
          setTimeout(() => {
            this.scrollToTheMessage()
            this.errors.clear()
          }, 100)
        }).catch((err) => {
          this.formStatus.submitting = false
          this.serverValidation.errors = err
          this.disableAPI = false
          this.formStatus.shown = true
          this.formStatus.success = false
          this.formStatus.title = err.body.message || 'Your need help request was not submitted.'
          this.formStatus.body = 'It looks like there was an error and your need help request could not be sent. Please try again or give us a call and we\'ll have our support team help you.'
          setTimeout(() => {
            this.scrollToTheMessage()
          }, 100)
        })
      })
    },
    scrollToTheMessage () {
      let elem = document.querySelector('.tcc-form-message')
      if (elem) {
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    },
    setupRightHeroStickyTopPosition () {
      let header = document.querySelector('header.app-header .app-header-main')
      let stickyDiv = document.querySelector('.hero-section .right-content')
      if (header && stickyDiv) {
        let rect = header.getBoundingClientRect()
        stickyDiv.style.top = (rect.height / 16) + 'rem'
      }
    },
    heroImageHeightFix () {
      let imageContainer = document.querySelector('.hero-section .right-content')
      let image = document.querySelector('.hero-section .hero-image')
      let header = document.querySelector('header')
      let maxHeight = window.innerHeight
      if (header) {
        maxHeight -= header.offsetHeight
      }
      if (imageContainer && image) {
        imageContainer.style.height = `${maxHeight}px`
        image.style.maxHeight = `${maxHeight}px`
      }
    }
  },
  beforeMount () {
    this.getLandingPage()
  },
  mounted () {
    this.setFontSizeActive()
    this.setColorPaletteActive()
    this.heroImageHeightFix()
    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('resize', this.setupRightHeroStickyTopPosition)
    window.addEventListener('resize', this.heroImageHeightFix)
    window.addEventListener('scroll', this.setupRightHeroStickyTopPosition)
    if (this.$route.name === 'edit-register') {
      this.pageEditMode = true
      this.landingPanel = true
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('resize', this.setupRightHeroStickyTopPosition)
    window.removeEventListener('resize', this.heroImageHeightFix)
    window.removeEventListener('scroll', this.setupRightHeroStickyTopPosition)
  },
  components: {},
  watch: {
    'getConfData.actionConfirmed' (value) {
      if (value) {
        if (this.confOpened === 'edit') this.pageEditSwitchConfirmed()
        this.clearConfAction()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inform-popup {
  margin-bottom: 0;
  margin-top: 0;
  position: relative;
  min-height: 60px;
  max-width: 90%;
}
.inform-message-inner {
  position: absolute;
  top: 10px;
  left: 0;
  z-index: 99999999;
  width: 100%;
}
.company-landing .landing-page-wrapper.hero-section .hero-login {
  margin-bottom: 30px;
}
</style>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>
<style src="@/assets/scss/main/company-landing.scss" lang="scss" scoped></style>
<style src="@/assets/scss/main/homepage.scss" lang="scss" scoped></style>
<style src="@/assets/scss/components/subscriptions/register.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// NeedHelpRequest.vue?7e0d08ca